import createIcon from '../../createIcon';

/**
 * @component @name PhoneCallback
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi42MiAxMC43OTQxQzguMDYgMTMuNjI0MSAxMC4zOCAxNS45MzQxIDEzLjIxIDE3LjM4NDFMMTUuNDEgMTUuMTg0MUMxNS42OCAxNC45MTQxIDE2LjA4IDE0LjgyNDEgMTYuNDMgMTQuOTQ0MUMxNy41NSAxNS4zMTQxIDE4Ljc2IDE1LjUxNDEgMjAgMTUuNTE0MUMyMC41NSAxNS41MTQxIDIxIDE1Ljk2NDEgMjEgMTYuNTE0MVYyMC4wMDQxQzIxIDIwLjU1NDEgMjAuNTUgMjEuMDA0MSAyMCAyMS4wMDQxQzEwLjYxIDIxLjAwNDEgMyAxMy4zOTQxIDMgNC4wMDQxNEMzIDMuNDU0MTQgMy40NSAzLjAwNDE0IDQgMy4wMDQxNEg3LjVDOC4wNSAzLjAwNDE0IDguNSAzLjQ1NDE0IDguNSA0LjAwNDE0QzguNSA1LjI1NDE0IDguNyA2LjQ1NDE0IDkuMDcgNy41NzQxNEM5LjE4IDcuOTI0MTQgOS4xIDguMzE0MTQgOC44MiA4LjU5NDE0TDYuNjIgMTAuNzk0MVpNMjAuMTYgMy42OTQxNEwxOS40NSAyLjk5NDE0TDEzIDkuMjk0MTRWNS4wMDQxNEgxMlYxMS4wMDQxSDE4VjEwLjAwNDFIMTMuODVMMjAuMTYgMy42OTQxNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhoneCallback = createIcon('PhoneCallback', [
  [
    'path',
    {
      d: 'M6.62 10.7941C8.06 13.6241 10.38 15.9341 13.21 17.3841L15.41 15.1841C15.68 14.9141 16.08 14.8241 16.43 14.9441C17.55 15.3141 18.76 15.5141 20 15.5141C20.55 15.5141 21 15.9641 21 16.5141V20.0041C21 20.5541 20.55 21.0041 20 21.0041C10.61 21.0041 3 13.3941 3 4.00414C3 3.45414 3.45 3.00414 4 3.00414H7.5C8.05 3.00414 8.5 3.45414 8.5 4.00414C8.5 5.25414 8.7 6.45414 9.07 7.57414C9.18 7.92414 9.1 8.31414 8.82 8.59414L6.62 10.7941ZM20.16 3.69414L19.45 2.99414L13 9.29414V5.00414H12V11.0041H18V10.0041H13.85L20.16 3.69414Z',
      key: '1hs89s',
    },
  ],
]);

export default PhoneCallback;
